import React, { useRef, useState } from "react";
import CustomInput from "../../components/Form/Input";
import DropDownNew from "../../components/Form/DropDownNew";
import FileUploadInput from "../../components/Form/FileUploadInput";
import showToast from "../../utils/toastNotifications";
import useForm from "../../hooks/useForm";

const FormTestArea = () => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const fileInputRef = useRef(null);

    const {
        formData,
        errors,
        touched,
        handleInputChange,
        handleBlur,
        validateForm,
        setTouched,
        clearError,
    } = useForm(
        {
            tenantName: "",
            email: "",
            phone: "",
            address: "",
            notification: { value: "SMS", label: "SMS" },
            comments: "",
            documents: null,
            countryCode: "+1",
        },
        {
            tenantName: true,
            phone: true,
            address: true,
        },
        {}
    );

    const handleSubmit = (e) => {
        e.preventDefault();

        handleBlur("tenantName", formData.tenantName);
        handleBlur("phone", formData.phone);
        handleBlur("address", formData.address);

        const isValid = validateForm();
        if (isValid) {
            showToast("success", "Tenant assigned successfully");
        } else {
            showToast("error", "Please fill all required fields correctly.");
        }
    };

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setUploadedFiles((prev) => [...prev, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    };

    return (
        <div className="w-full px-4 py-10">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white text-center bg-gradient-to-r from-[#873FE2] to-[#4772F1] py-6 shadow-lg opacity-50">
                LandLord Play Area
            </h1>
            <div className="mx-auto bg-white rounded-xl shadow-md p-6 sm:p-8 mt-10 max-w-full md:max-w-[1080px]">
                <form
                    className="flex flex-col gap-y-4 sm:gap-y-6"
                    onSubmit={handleSubmit}
                >
                    {/* Tenant Name */}
                    <CustomInput
                        label={
                            <span className="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium">
                Tenant Name <span className="text-[#C00707]">*</span>
              </span>
                        }
                        type="text"
                        name="tenantName"
                        value={formData.tenantName}
                        placeholder="Enter tenant name"
                        error={touched.tenantName && errors.tenantName}
                        onChange={(e) => handleInputChange("tenantName", e.target.value)}
                        onBlur={() => handleBlur("tenantName", formData.tenantName)}
                        onFocus={() => clearError("tenantName")}
                        labelStyle="text-[#09114B] text-[17px] font-inter font-medium"
                        inputStyle="text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]"
                        className="
              inline-flex items-center flex-shrink-0
              border border-gray-300
              bg-primary-light/30 text-content
              placeholder:text-[#9D9D9D] placeholder:text-[9px] sm:placeholder:text-[11px] md:placeholder:text-[13px] lg:placeholder:text-[15px]
              h-8 sm:h-9 md:h-10 lg:h-[45px] rounded-[5px] px-[13px] py-[14px]
            "
                    />

                    {/* Email and Phone */}
                    <div className="flex flex-col md:flex-row gap-y-4 md:gap-6">
                        <CustomInput
                            label={
                                <span className="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium">
                  Email Address
                </span>
                            }
                            type="email"
                            name="email"
                            value={formData.email}
                            placeholder="Enter email address"
                            onChange={(e) => handleInputChange("email", e.target.value)}
                            onBlur={() => handleBlur("email", formData.email)}
                            onFocus={() => clearError("email")}
                            labelStyle="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-inter font-medium"
                            inputStyle="text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]"
                            className="
                inline-flex items-center flex-shrink-0
                text-content w-full
                bg-primary-light/30
                placeholder:text-[#9D9D9D] placeholder:text-[9px] sm:placeholder:text-[11px] md:placeholder:text-[13px] lg:placeholder:text-[15px]
                h-8 sm:h-9 md:h-10 lg:h-[45px]
                py-[6px] px-[13px]
                rounded-[5px]
                border border-[rgba(129,129,129,0.5)]
              "
                        />

                        {/* Phone number */}
                        <div className="w-full">
              <span className="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium">
                Phone Number <span className="text-[#C00707]">*</span>
              </span>
                            <div className="flex items-center w-full gap-2 mt-1 sm:mt-2">
                                {/* Country Code */}
                                <div className="relative w-[75px] sm:w-[80px]">
                                    <select
                                        value={formData.countryCode}
                                        onChange={(e) =>
                                            handleInputChange("countryCode", e.target.value)
                                        }
                                        className="
                      block w-full
                      h-8 sm:h-9 md:h-10 lg:h-[45px]
                      pl-3 pr-8 bg-white border border-[#81818180] rounded-[5px] text-content
                      text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]
                      focus:outline-none focus:ring-2 focus:ring-white appearance-none cursor-pointer
                    "
                                    >
                                        <option value="+1">+1</option>
                                        <option value="+91">+91</option>
                                        <option value="+44">+44</option>
                                        <option value="+61">+61</option>
                                        <option value="+81">+81</option>
                                    </select>
                                    <div className="absolute inset-y-0 flex items-center pointer-events-none right-2">
                                        <svg
                                            className="w-4 h-4 text-gray-600"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                {/* Input Number */}
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone number"
                                    value={formData.phone}
                                    onChange={(e) => handleInputChange("phone", e.target.value)}
                                    onBlur={() => handleBlur("phone", formData.phone)}
                                    onFocus={() => clearError("phone")}
                                    className={`
                    flex-grow w-[calc(100%-85px)] sm:w-auto
                    h-8 sm:h-9 md:h-10 lg:h-[45px]
                    px-4 bg-white rounded-[5px] text-content focus:outline-none focus:ring-2 focus:ring-white
                    text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]
                    placeholder:text-[#9D9D9D]
                    border ${
                                        touched.phone && errors.phone
                                            ? "border-red-500"
                                            : "border-[#81818180]"
                                    }
                  `}
                                />
                            </div>
                            {touched.phone && errors.phone && (
                                <p className="mt-1 text-sm text-red-500">{errors.phone}</p>
                            )}
                        </div>
                    </div>

                    {/* Tenant Address */}
                    <CustomInput
                        label={
                            <span className="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium">
                Tenant Address <span className="text-red-500">*</span>
              </span>
                        }
                        type="text"
                        name="address"
                        value={formData.address}
                        placeholder="Enter tenant address"
                        error={touched.address && errors.address}
                        onChange={(e) => handleInputChange("address", e.target.value)}
                        onBlur={() => handleBlur("address", formData.address)}
                        onFocus={() => clearError("address")}
                        labelStyle="text-[#09114B] text-[17px] font-inter font-medium"
                        className={`
              text-content bg-white
              placeholder:text-[#9D9D9D] placeholder:text-[9px] sm:placeholder:text-[11px] md:placeholder:text-[13px] lg:placeholder:text-[15px]
              w-full 
              h-8 sm:h-9 md:h-10 lg:h-[45px]
              rounded-[5px]
              py-[6px] px-[13px]
              text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]
              ${
                            touched.address && errors.address
                                ? "border border-red-400"
                                : "border border-[rgba(129,129,129,0.5)]"
                        }
            `}
                    />

                    {/* Notification Preference */}
                    <div className="relative w-full sm:w-[295px] md:w-[395px] lg:w-[495px] mt-8">
                        <DropDownNew
                            label="Notification Preference"
                            options={[
                                { label: "SMS", value: "SMS" },
                                { label: "Email", value: "Email" },
                            ]}
                            defaultOption={formData.notification}
                            onSelect={(value) => handleInputChange("notification", value)}
                            placeholder="SMS"
                            displayKey="label"
                            idKey="value"
                            isForm
                            isRequired
                            allowFillColor
                            buttonClassName="rounded-[0px] h-[45px] w-full border border-[#81818180] text-[13px]"
                            dropdownClassName="w-full relative -top-1  rounded-[0px] "
                            labelStyle="-top-[30px] left-[-2px]  font-inter text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium"
                        />
                    </div>

                    {/* Comments */}
                    <div>
                        <CustomInput
                            label="Comments (Optional)"
                            type="textarea"
                            name="comments"
                            placeholder="Add internal notes or special instruction..."
                            value={formData.comments}
                            onChange={(e) => handleInputChange("comments", e.target.value)}
                            onBlur={() => handleBlur("comments", formData.comments)}
                            onFocus={() => clearError("comments")}
                            labelStyle="text-[#09114B] text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] font-medium"
                            inputStyle="text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px]"
                            className="
                placeholder:text-[#9D9D9D]
                placeholder:text-[9px] sm:placeholder:text-[11px] md:placeholder:text-[13px] lg:placeholder:text-[15px]
                border border-[rgba(129,129,129,0.5)]
                h-[80px] py-[6px] px-[13px]
              "
                            outerContainerStyle="mt-3"
                        />
                    </div>

                    {/* File Upload */}
                    <FileUploadInput
                        fileInputRef={fileInputRef}
                        onFileChange={handleFileChange}
                        files={uploadedFiles}
                        onRemoveFile={handleRemoveFile}
                    />

                    <div className="flex justify-center gap-3 mt-6 sm:gap-5 sm:mt-8">
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="
                h-[30px] sm:h-[45px] md:h-[55px]
                w-[90px] sm:w-[100px] md:w-[120px]
                border border-[#4772F1]
                text-[#4772F1] font-bold rounded-[8px]
                hover:bg-[#f0f4ff]
                text-[10px] sm:text-[11px] md:text-[13px] lg:text-[15px]
              "
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="
                h-[30px] sm:h-[45px] md:h-[55px]
                w-[120px] sm:w-[150px] md:w-[170px]
                bg-[#4772F1] text-white font-bold rounded-[8px]
                hover:bg-[#5c81ef]
                text-[10px] sm:text-[11px] md:text-[13px] lg:text-[15px]
              "
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FormTestArea;